import axios from "axios";
import Config from "../../config";

const actionListaTarefasPorChat = (chatId) => {
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/tarefas/por-chat/${chatId}`
    });
};

export default actionListaTarefasPorChat;
